import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import ResetPasswordDisplay from './ResetPasswordDisplay';

class ResetPasswordContainer extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    resetPassword: PropTypes.func.isRequired,
    resetPasswordLoading: PropTypes.bool.isRequired,
    resetPasswordSuccess: PropTypes.bool.isRequired
  };

  state = {
    form: {
      newPassword: '',
      confirmPassword: ''
    },
    errors: {
      newPassword: undefined,
      confirmPassword: undefined
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.resetPasswordSuccess && this.props.resetPasswordSuccess) {
      this.props.history.push('/login/resetSuccess');
    }
  }

  getToken = () => {
    const params = new URLSearchParams(this.props.location.search);
    return params.get('token');
  }

  onKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      this.onSubmit();
    }
  }

  onChange = (field, value) => {
    this.setState(prevState => ({
      form: { ...prevState.form, [field]: value }
    }));
  }

  validateForm = () => {
    const { form } = this.state;
    const errors = {};
    let isValid = true;

    if (form.newPassword === '') {
      errors.newPassword = 'Enter a new password';
      isValid = false;
    } else if (form.newPassword.length < 6 || form.newPassword.length > 12) {
      errors.newPassword = 'Password must be between 6 and 12 characters';
      isValid = false;
    } else if (!/[A-Z]/.test(form.newPassword)) {
      errors.newPassword = 'Password must contain at least one uppercase letter';
      isValid = false;
    } else if (!/[a-z]/.test(form.newPassword)) {
      errors.newPassword = 'Password must contain at least one lowercase letter';
      isValid = false;
    } else if (!/[0-9]/.test(form.newPassword)) {
      errors.newPassword = 'Password must contain at least one digit';
      isValid = false;
    }

    if (form.confirmPassword === '') {
      errors.confirmPassword = 'Confirm your password';
      isValid = false;
    } else if (form.newPassword !== form.confirmPassword) {
      errors.confirmPassword = 'Passwords do not match';
      isValid = false;
    }

    if (!isValid) {
      return errors;
    }
    return null;
  }

  onSubmit = () => {
    const errors = this.validateForm();
    if (errors === null) {
      const token = this.getToken();
      if (!token) {
        this.setState({
          errors: { newPassword: 'Invalid or missing reset token', confirmPassword: undefined }
        });
        return;
      }
      const { resetPassword } = this.props;
      const { form } = this.state;
      resetPassword(token, form.newPassword, form.confirmPassword);
    } else {
      this.setState({ errors });
    }
  }

  backToLogin = () => {
    this.props.history.push('/login');
  }

  render() {
    return (
      <ResetPasswordDisplay
        form={ this.state.form }
        errors={ this.state.errors }
        onChange={ this.onChange }
        onKeyDown={ this.onKeyDown }
        onSubmit={ this.onSubmit }
        backToLogin={ this.backToLogin }
        loading={ this.props.resetPasswordLoading }
      />
    );
  }
}

export default withRouter(ResetPasswordContainer);
